import React  , {useContext , useState} from 'react';
import Orbit from '../orbit';
import { sideEnum , travelTypeEnum} from '../../../../common/enum';
import DateHour from '../date-hour'
import CarType from '../car-type';
import Context from '../../../../context/context';



const InviteBack = () => {
        const {state, dispatch} = useContext(Context);
    return (
        <div>
            <DateHour isInviteBack={true}></DateHour>
            {state.tripType === travelTypeEnum.private ?<CarType isInviteBack={true}></CarType>: <></>}
            <Orbit hideSides={true} side={sideEnum.fromUman} isInviteBack={true}></Orbit>
            
        </div>
    )

}

export default InviteBack;